import domAdapter from 'devextreme/core/dom_adapter';

// In modern browsers (Chromium 115+), the 'unload' event is deprecated and disallowed
// by Permissions Policy, causing console violations whenever 'unload' listeners are attached.
// The modern, recommended standard is 'pagehide'.

// 1. Intercept DevExtreme's internal DOM adapter:
try {
  domAdapter.inject({
    listen(element, event, callback, options) {
      const actualEvent = event === 'unload' ? 'pagehide' : event;
      return this.callBase(element, actualEvent, callback, options);
    },
  });
} catch (e) {
  // If domAdapter is not available or already configured
}

// 2. Intercept native window.addEventListener for any direct 'unload' registrations:
if (typeof window !== 'undefined' && window.addEventListener) {
  const originalAdd = window.addEventListener.bind(window);
  const originalRemove = window.removeEventListener.bind(window);

  window.addEventListener = function (type, listener, options) {
    if (type === 'unload') {
      return originalAdd('pagehide', listener, options);
    }
    return originalAdd(type, listener, options);
  };

  window.removeEventListener = function (type, listener, options) {
    if (type === 'unload') {
      return originalRemove('pagehide', listener, options);
    }
    return originalRemove(type, listener, options);
  };
}
